/**
 * Generic business event names.
 *
 * These are vendor-agnostic — components emit these events without knowing
 * which tracking vendors are listening. Each vendor (Bloomreach, GTM, etc.)
 * subscribes and maps to their own event names/formats.
 */
export const EmitterEvent = {
    /** User views a product (PDP or mini-PDP popup). */
    VIEW_ITEM: 'view_item',
    /** User navigates to a category/lister page. */
    CATEGORY_VIEW: 'view_category',
    /** User views a pure search-results page (no category context). */
    SEARCH_RESULTS_VIEW: 'view_search_results',
    /** User adds or removes a product from the basket. */
    CART_UPDATE: 'cart_update',
    /** A product (main or additional/cross-sell) is added to the basket via the PDP
     * "additional products" flow. Kept separate from CART_UPDATE so vendors that don't
     * cover this flow today aren't affected just by opting into cart tracking generally. */
    ADDITIONAL_PRODUCT_CART_ADD: 'additional_product_cart_add',
    /** User clicks a product tile (lister, campaign tile, or recommendation widget). */
    PRODUCT_CLICK: 'product_click',
    /** User clicks a filter/facet value. */
    FACET_CLICK: 'facet_click',
    /** A product line within a completed order (emitted once per product, not once per order). */
    PURCHASE: 'purchase',
    /** User logs out of their account. */
    LOGOUT: 'logout',
};
